export default "__VITE_ASSET__BEjeNeHq__"